import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,DateField
 }
from 'admin-on-rest/lib/mui';

export const CHBList = (props) => (
    <List perPage={30} title="CHB" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
            
            <TextField label="מ. עסק" source="buisiness_id"/>
            <TextField label="כ.אשראי" source="cc_id"/>
            <TextField label="סהכ" source="chb_total"/>
            <TextField label="שער תנועה" source="tnua_currency"/>
            <DateField label="ת. רכישה" source="rechisha_date.date" locales="he-IL"/>            
            <TextField label="קוד סיבה" source="kod_siba"/>
            
            <TextField label="ח. אשראי" source="cc_company"/>
            <TextField label="תיאור סוג תנועה" source="teur_sug_tnua"/>
            <TextField label="קוד שימוש תנועה" source="kod_shimush_tnua" />
            <TextField label="סוג תנועה" source="sug_tnua"/> 
            <TextField label="סהכ מקורי" source="original_sum"/>
            <TextField label="שער מקורי" source="original_currency"/>
            <TextField label="source_file" source="source_file" />
            
            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.id}` : ''}</span>;
};


export const CHBShow = (props) => (

<Show title={<PostTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
         
            <TextField label="מ. עסק" source="buisiness_id"/>
            <TextField label="כ.אשראי" source="cc_id"/>
            <TextField label="סהכ" source="chb_total"/>
            <DateField label="ת. רכישה" source="rechisha_date.date" locales="he-IL"/>
            <DateField label="ת. קליטה" source="klita_date.date" locales="he-IL"/>
            <TextField label="ריכוז תנועת מקור" source="rikuz_tnuat_makor"/>
            <TextField label="אחזור תנועת מקור" source="ichzur_tnuat_makor"/>
            <TextField label="קוד סיבה" source="kod_siba"/>
            <TextField label="arn" source="arn"/>
            <TextField label="מטבע תנועה" source="tnua_currency"/>
            <TextField label="צזהה תנועה" source="mezahe_tnua"/>
            <TextField label="חברת אשראי" source="cc_company"/>
            <TextField label="תיאור סוג תנועה" source="teur_sug_tnua"/>
            <TextField label="קוד שימוש תנועה" source="kod_shimush_tnua" />
            <DateField label="זמן רכישה" source="rechisha_datetime.date" showTime  locales="he-IL"/>
            
            <TextField label="קוד חברת אשראי" source="kod_cc_company"/>
            <TextField label="סוג תנועה" source="sug_tnua"/>
            <TextField label="מזהה רשת" source="external_id"/>
            <TextField label="מספר ריכוז" source="rikuz_number"/>
            <TextField label="סהכ מקורי" source="original_sum"/>
            <TextField label="מטבע מקורי" source="original_currency"/>
            
            <TextField label="source_file" source="source_file" />
            

         </SimpleShowLayout>
    </Show>
);

       
         





              



// WEBPACK FOOTER //
// ./src/components/CHB/chb.js